import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportAssistenciaTecnicaUseCase } from "../../../presentation/useCases/read/get_report_assistencia_tecnica_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { ReportData } from "../../models/report_data";

import dayjs from "dayjs";

/**
 * GetReportAssistenciaTecnicaUseCase
 */

export class GetReportAssistenciaTecnicaUseCase implements IGetReportAssistenciaTecnicaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportAssistenciaTecnica(
    requiredMimeType: ReportMimeType | null,
    codigo: number | null,
    nroChamado: string | null,
    status: number | null,
    dataAbertura: (Date | null)[] | null,
    unidade: string | null,
    procedente: number[],
    categoria: string[],
    resolvido: number[],
    dataEncerramento: (Date | null)[] | null,
    clientes: number[],
    centroCustos: number[],
    prioridade: number[],
  ): Promise<ReportData> {
    const response = await this.repository.getReportAssistenciaTecnica(
      requiredMimeType,
      codigo,
      nroChamado,
      status,
      dataAbertura,
      unidade,
      procedente,
      categoria,
      resolvido,
      dataEncerramento ? dataEncerramento : null,
      clientes,
      centroCustos,
      prioridade,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `assistencias_tecnicas_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
